module.exports = "<mat-progress-spinner mode=\"indeterminate\" color=\"warn\"></mat-progress-spinner>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/loader/loader.component.html
// module id = ./src/app/components/loader/loader.component.html
// module chunks = main